import SearchEngineAdapter from 'Services/Adapters/SearchEngine/SearchEngineAdapter';
import CompanyAdapter from 'Services/Adapters/SearchEngine/CompanyAdapter';
import ContactAdapter from 'Services/Adapters/SearchEngine/ContactAdapter';
import IndividualAdapter from 'Services/Adapters/SearchEngine/IndividualAdapter';
import OpportunityAdapter from 'Services/Adapters/SearchEngine/OpportunityAdapter';
import ProductAdapter from './ProductAdapter';
import SalesDocumentAdapter from './SalesDocumentAdapter';
import DeclinationAdapter from 'Services/Adapters/SearchEngine/DeclinationAdapter';

/**
 * List of adapters available for archive search result
 * When a new type of archive result is avaible, add the corresponding adapter in the list
 */
const adapters = {
    CompanyAdapter,
    ContactAdapter,
    IndividualAdapter,
    OpportunityAdapter,
    DeclinationAdapter,
    ProductAdapter,
    SalesDocumentAdapter,
};

export default class ArchivedAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'archived';
    }

    constructor(data = []) {
        super(data);
        this.key = ArchivedAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Archivé'),
            count: 0,
            items: [],
        };
    }

    extractDataByType() {
        return this.data ? this.data.filter((item) => item.is_archived) : [];
    }

    /**
     * Return the good adapter by comparing item.object.type to the static _key of adapters
     * If no adapter has been registered, log error for sentry and return empty object to continue execution
     */
    formatItem(item) {
        const adapter = Object.values(adapters).find(
            (adapter) => adapter._key === item.object.type,
        );

        try {
            return new adapter().formatItem(item);
        } catch (error) {
            console.error('[Result archived] Adapter not found', error);
            return {};
        }
    }
}
